import type { AgentV2ConversationDetailResponse } from '@/agent-v2/store/schemas'

/** Merge returned records while retaining history outside the incoming page. */
export function mergeConversationDetail(
  existing: AgentV2ConversationDetailResponse | undefined,
  incoming: AgentV2ConversationDetailResponse
): AgentV2ConversationDetailResponse {
  if (!existing) return incoming
  const turns = new Map(existing.turns.map((turn) => [turn.id, turn]))
  for (const turn of incoming.turns) turns.set(turn.id, turn)
  const references = new Map(existing.references.map((reference) => [reference.reference_id, reference]))
  for (const reference of incoming.references) references.set(reference.reference_id, reference)
  const versions = new Map(existing.artifact_versions.map((version) => [version.id, version]))
  for (const version of incoming.artifact_versions) versions.set(version.id, version)
  const scopeVersions = [...incoming.artifact_versions, ...incoming.turns.flatMap((turn) => turn.artifact_versions)]
  const artifactIds = new Set(scopeVersions.map((version) => version.matter_artifact_id))
  const versionIds = new Set(scopeVersions.map((version) => version.id))
  return {
    ...incoming,
    turns: [...turns.values()].sort((a, b) => Date.parse(a.started_at) - Date.parse(b.started_at) || a.id.localeCompare(b.id)),
    references: [...references.values()],
    artifact_versions: [...versions.values()],
    template_selections: [
      ...existing.template_selections.filter((selection) => !artifactIds.has(selection.matter_artifact_id)),
      ...incoming.template_selections,
    ],
    applied_templates: [
      ...existing.applied_templates.filter((template) => !versionIds.has(template.matter_artifact_version_id)),
      ...incoming.applied_templates,
    ],
  }
}
